import React from 'react';

/**
 * @typedef LottieProps
 * @property {unknown} [autoplay]
 * @property {unknown} [loop]
 * @property {unknown} [src]
 * @property {unknown} [style]
 * @property {unknown} [className]
 */

/**
 * @param {LottieProps} props
 * @returns {React.ReactElement | null}
 */
const Lottie = (props) => {
	const [Player, setPlayer] = React.useState(null);

	React.useEffect(() => {
		let isMounted = true;

		import('@lottiefiles/react-lottie-player')
			.then((mod) => {
				if (!isMounted) return;
				setPlayer(() => mod.Player);
			})
			.catch(() => {
				// fail closed
			});

		return () => {
			isMounted = false;
		};
	}, []);

	if (!Player) return null;

	return <Player {...props} />;
};

export default Lottie;
